import api from "./apiAgent";

export const submitFormData = (formData: any) => {
  const { code, body } = formData;
  return api.post(`plantlocations/updatePlantConfig?location=${code}`, body);
};
